// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DynamicImage_wrapper__1HWGM","children":"DynamicImage_children__20eK-","image":"DynamicImage_image__2v0u7"};